import { cn } from '@/lib/utils';
import { CSSProperties } from 'react';

interface Chevron {
  left: string;
  top: string;
  size: number;
  delay: number;
  duration: number;
  direction: 'forward' | 'back';
}

const SIZES = [22, 28, 34, 25, 40, 31, 20];

// A deterministic field keeps the composition stable while allowing the
// percentage-based positions to respond naturally to the available width.
const CHEVRONS: Chevron[] = Array.from({ length: 56 }, (_, index) => ({
  left: `${(index * 23 + (index % 4) * 7) % 97}%`,
  top: `${(index * 37 + Math.floor(index / 5) * 9) % 91}%`,
  size: SIZES[index % SIZES.length],
  delay: -((index * 0.41) % 4.8),
  duration: 3.2 + (index % 7) * 0.35,
  direction: index % 2 === 0 ? 'forward' : 'back'
}));

interface Props {
  compact?: boolean;
}

export default function AmbientSquares({ compact = false }: Props) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'ambient-square-field',
        compact && 'ambient-square-field--compact'
      )}
    >
      {CHEVRONS.map((chevron) => (
        <span
          key={`${chevron.left}-${chevron.top}-${chevron.size}`}
          className="ambient-square"
          data-direction={chevron.direction}
          style={
            {
              '--square-left': chevron.left,
              '--square-top': chevron.top,
              '--square-size': `${chevron.size}px`,
              '--square-delay': `${chevron.delay}s`,
              '--square-duration': `${chevron.duration}s`
            } as CSSProperties
          }
        >
          {chevron.direction === 'forward' ? '›' : '‹'}
        </span>
      ))}
    </div>
  );
}
